import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=13e7ed1a&scoped=true&"
import script from "./Confirm.js?vue&type=script&lang=js&"
export * from "./Confirm.js?vue&type=script&lang=js&"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=13e7ed1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e7ed1a",
  null
  
)

export default component.exports